import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ITable } from '../types/ITable';
import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IMaxDownstreamDatasources, IMaxDownstreamWorkbooks } from '../types/IMaxDownstreamConnections';

export interface IGetTablesParams extends IGetItemsParams {
}

export interface IGetTablesResult extends IGetItemsResult {
  tables?: ITable[];
  maxDownstreamDatasourcesViewModel?: IMaxDownstreamDatasources;
  maxDownstreamWorkbooksViewModel?: IMaxDownstreamWorkbooks;
}

export class GetTablesRequest extends Request<IGetTablesParams, IGetTablesResult> {
  constructor(params: IGetTablesParams) {
    super('getTables', params);
  }
}